import { useQuery } from '@tanstack/react-query';
import { IGallery } from '@clickersphere/core/entities/IGallery';
import GalleryService from '@clickersphere/core/services/GalleryService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const GALLERIES_QUERY_KEY = 'galleries';

export type GalleryQueryData = WithQueryStatus<IGallery>;

export function useGalleries(leadId: string) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: galleries,
    isSuccess: isGalleriesSuccess,
    isFetching: isGalleriesFetching,
    isLoading: isGalleriesLoading,
  } = useQuery({
    queryKey: buildQueryKey([GALLERIES_QUERY_KEY, leadId]),
    queryFn: async () => {
      const data = await GalleryService.getAll(leadId);
      return data as GalleryQueryData[];
    },
    enabled: !!leadId && !!selectedTenantId,
    staleTime: 1000 * 60 * 5,
  });

  return {
    galleries,
    isGalleriesSuccess,
    isGalleriesFetching,
    isGalleriesLoading,
  };
}
